<template>
  <Modal
    :title="getModalTitle"
    :saving="saving"
    :width="850"
    class="address-modal"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSaveAddress"
  >
    <AddressForm
      ref="addressForm"
      :address="address"
      :hide-billing-address-toggle="hideBillingAddressToggle"
    >
      <template #tax-fields>
        <TaxSettingsForm
          v-if="taxSettingsFormVisible"
          ref="taxSettingsForm"
          is-new
          context-type="Address"
          :context="customer.id"
          class="mb-3"
        />
      </template>
    </AddressForm>
    <slot />
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import TaxSettingsForm from "@/Taxability/TaxSettingsForm.vue";
import useVuelidate from "@vuelidate/core";
import AddressForm from "./AddressForm.vue";

export default {
  components: {
    Modal,
    AddressForm,
    TaxSettingsForm
  },
  props: {
    customer: {
      type: Object,
      default: null
    },
    address: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal", "success-address-created"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      saving: false,
      isAreaCovered: true,
      showManualInput: false,
      isEditing: false
    };
  },
  computed: {
    ...mapGetters(["featureEnabledForTenant"]),
    ...mapState({
      currentUser: "currentUser"
    }),

    // Only show tax settings for new addresses
    taxSettingsFormVisible() {
      return !this.isEditing;
    },
    getModalTitle() {
      return this.isEditing ? this.address.name : "New Address";
    },
    hideBillingAddressToggle() {
      return this.customer.parent?.delegate_billing;
    }
  },
  mounted() {
    if (this.address && this.address.id) {
      this.isEditing = true;
    }
  },
  methods: {
    ...mapActions(["createUserAddress", "updateUserAddress"]),
    parseAddressNotFoundError(error) {
      if (error?.response?.data?.message?.includes("Address Not found")) {
        this.$refs.addressForm.setAddressNotFoundError(true);
      }
    },
    async handleSaveAddress() {
      const data = await this.$refs.addressForm.getFormData();
      if (!data) return;
      if (this.taxSettingsFormVisible) {
        const taxFormData = await this.$refs.taxSettingsForm.getFormData();
        data.tax_setting = {
          taxability: taxFormData.taxability,
          tax_zone_id: taxFormData.tax_zone_id,
          reason: taxFormData.reason || null
        };
      }
      if (data) {
        this.saving = true;
        if (this.isEditing) {
          this.updateUserAddress({
            user_id: this.currentUser.id,
            address_id: data.id,
            data: {
              address: {
                ...data
              }
            }
          })
            .then((address) => {
              window.notify.success(`Address Updated Successfully!`);
              this.$emit("success-address-created", address);
              this.$emit("hide-modal");
            })
            .catch((error) => {
              this.parseAddressNotFoundError(error);
            })
            .finally(() => (this.saving = false));
        } else {
          this.createUserAddress({
            user_id: this.currentUser.id,
            data: {
              address: data
            }
          })
            .then((address) => {
              window.notify.success(`Address Created Successfully!`);
              this.$emit("success-address-created", address);
              this.$emit("hide-modal");
            })
            .catch((error) => {
              this.parseAddressNotFoundError(error);
            })
            .finally(() => (this.saving = false));
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>
